import styled, { css } from "styled-components";

export const Wrapper = styled.div(({ theme }) => css`
  padding: 24px;
  border-radius: 5px;
  border: solid 1px rgba(0, 0, 0, 0.05);
  height: 100%;
  box-sizing: border-box;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.05);

  h4 {
    margin: 0 0 16px;
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: -0.2px;
    color: ${theme.palette.text.heading};
  }

  p {
    margin: 16px 0;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: ${theme.palette.text.body};
  }
  ul {
    padding-left: 20px;
  }
  li {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: ${theme.palette.text.body};
    list-style: disc;
  }

  .button {
    padding: ${theme.buttons.primary.padding};
    border: ${theme.buttons.primary.border};
    background-color: ${theme.buttons.primary.background};
    color: ${theme.buttons.primary.color};
    border-radius: ${theme.buttons.borderRadius};
    cursor: pointer;
    text-align: center;
    margin: 12px auto 0;
    font-size: ${theme.buttons.fontSize};
    font-weight: ${theme.buttons.fontWeight};
    text-transform: ${theme.fonts.headingCase};
    transition: background 0.35s, border 0.35s;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    word-break: normal;
    @media (hover: hover) {
      &:hover {
        color: ${theme.buttons.primary.colorHover};
        background-color: ${theme.buttons.primary.backgroundHover};
      }
    }
  }
`);
